import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QuinielaMatch, QuinielaOption } from '@app/@shared/models/quiniela.model';
import { ProgolService } from '@app/@shared/services/progol.service';
import { ProtouchService } from '@app/@shared/services/protouch.service';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-quiniela',
  templateUrl: './quiniela.component.html',
  styleUrl: './quiniela.component.scss',
})
export class QuinielaComponent {
  @Input() matches: QuinielaMatch[] = [];
  @Input() protouchS?: ProtouchService;
  @Input() progolS?: ProgolService;
  @Input() isRevancha = false;
  @Input() isMediaSemana = false;

  @Output() changeQuiniela = new EventEmitter<QuinielaMatch[]>();

  constructor(private alertCtrl: AlertController, private translateS: TranslateService) {}

  async toggleSelection(match: QuinielaMatch, option: QuinielaOption) {
    const index = match.selected.indexOf(option);

    if (index === -1) {
      match.selected.push(option);
    } else {
      // if (match.selected.length === 1) {
      //   // no tanks
      // } else {
      match.selected.splice(index, 1);
      // }
    }

    if (this.protouchS) {
      const { doubles, triples } = this.protouchS.countDoublesAndTriples(this.matches);

      const allowedDoubles = this.protouchS.getMaxDoubles(triples);

      if (!allowedDoubles.includes(doubles)) {
        if (index === -1) {
          match.selected.pop();
        } else {
          match.selected.push(option);
        }

        const alert = await this.alertCtrl.create({
          header: 'Error',
          message: `La combinación de ${triples} triples y ${doubles} dobles en Protouch no es válida`,
          buttons: ['Ok'],
        });

        await alert.present();
      }
    } else if (this.progolS) {
      const { doubles, triples } = this.progolS.countDoublesAndTriples(this.matches);

      let allowedDoubles: number[];
      let allowedTriples: number[];
      if (this.isMediaSemana) {
        const doubTrip = this.progolS.getMaxDoublesMediaSemana(doubles, triples);
        allowedTriples = doubTrip.triples;
        allowedDoubles = doubTrip.doubles;
      } else if (this.isRevancha) {
        const doubTrip = this.progolS.getMaxDoublesRevancha(doubles, triples);
        allowedTriples = doubTrip.triples;
        allowedDoubles = doubTrip.doubles;
      } else {
        const doubTrip = this.progolS.getMaxDoublesProgol(doubles, triples);
        allowedTriples = doubTrip.triples; //.filter((n) => n);
        allowedDoubles = doubTrip.doubles; //.filter((n) => n);
      }

      if (!allowedDoubles.includes(doubles)) {
        //revisar si es uno mayor al maximo
        if (!allowedDoubles.includes(doubles - 1)) {
          if (index === -1) {
            match.selected.pop();
          } else {
            match.selected.push(option);
          }
        }

        const maxTriples = allowedTriples.length ? Math.max(...allowedTriples) : triples;
        const maxDoubles = allowedDoubles.length
          ? Math.max(...allowedDoubles)
          : allowedTriples.length
          ? doubles
          : doubles - 1;

        //console.log({  md: this.isMediaSemana,  allowedDoubles,  allowedTriples,  doubles,  triples,  maxTriples,  maxDoubles,});

        let forwardText = '';

        //
        if (doubles > 0 && triples > 0) {
          if (allowedTriples.length === 0 || allowedDoubles.length) {
            forwardText = ` y ${maxDoubles} dobles`;
          } else {
            forwardText = ` y ${maxTriples} triples`;
          }
        }

        const alert = await this.alertCtrl.create({
          header: 'На ехсedido el límite de combinaciones de dobles y triples permitidas',
          subHeader:
            this.translateS
              .instant('progol.validDoublesTriples')
              .replace('{{max}}', `${maxTriples > 0 ? maxTriples : maxDoubles}`)
              .replace('{{type}}', `${maxTriples ? 'triples' : 'dobles'}`) + forwardText,
          message: this.translateS
            .instant('error.quiniela.doublesTriples')
            .replace('{{doubles}}', `${doubles}`)
            .replace('{{triples}}', `${triples}`)
            .replace('{{type}}', this.isMediaSemana ? 'Progol 1/2 Semana' : this.isRevancha ? 'Revancha' : 'Progol'),
          buttons: ['Ok'],
        });

        await alert.present();
      }
    }
    this.changeQuiniela.emit(this.matches);
  }

  isSelected(match: QuinielaMatch, option: QuinielaOption): boolean {
    return match.selected.includes(option);
  }
}
